import { InputNumber } from "@/components/InputNumber";
import { validations } from "@/utils/validationUtils";
import { Checkbox, Col, Form, Row } from "antd";
import { useTranslation } from "react-i18next";
import { rowGutter } from "../../../../../../../common/constants";
import { CoverageLimitSelect } from "../../../../../../enumerations/components/form/CoverageLimitSelect";
import { CreateUpdateInsuranceContract } from "../../../../../types";
import { StandardVehicleInsuranceFormPart } from "./StandardVehicleInsuranceFormPart";

const colSpan = 4;

type Props = {
  index: number;
  formNameDataPrefix: (string | number)[];
  formNameCoveragesPrefix: (string | number)[];
  formNamePrefix: (string | number)[];
};

export const MtplInsuranceFormPart = ({
  index,
  formNameDataPrefix,
  formNameCoveragesPrefix,
  formNamePrefix,
}: Props) => {
  const { t } = useTranslation();

  const form = Form.useFormInstance<CreateUpdateInsuranceContract>();
  const institutionId = Form.useWatch("institutionId", form);
  const glass = Form.useWatch<boolean | undefined>([...formNameCoveragesPrefix, "glass"], form);

  return (
    <>
      <Row gutter={rowGutter}>
        <Col span={colSpan}>
          <CoverageLimitSelect
            formItemProps={{
              name: [...formNamePrefix, "coverageLimitId"],
              label: t("contract.attrs.insurances.coverageLimitId"),
              rules: [validations.notNull],
            }}
            institutionId={institutionId}
          />
        </Col>

        <StandardVehicleInsuranceFormPart formNameDataPrefix={formNameDataPrefix} index={index} />

        <Col span={colSpan}>
          <Form.Item
            name={[...formNameCoveragesPrefix, "extendedAssistance"]}
            valuePropName="checked"
            rules={[validations.none]}
            initialValue={false}
            className="form-item-without-label"
          >
            <Checkbox>{t("contract.attrs.insurances.insuranceData.coverages.extendedAssistance")}</Checkbox>
          </Form.Item>
        </Col>

        <Col span={colSpan}>
          <Form.Item
            name={[...formNameCoveragesPrefix, "glass"]}
            valuePropName="checked"
            rules={[validations.none]}
            initialValue={false}
            className="form-item-without-label"
          >
            <Checkbox>{t("contract.attrs.insurances.insuranceData.coverages.glass")}</Checkbox>
          </Form.Item>
        </Col>

        <Col span={colSpan}>
          {glass && (
            <Form.Item
              name={[...formNameCoveragesPrefix, "glassAmount"]}
              label={t("contract.attrs.insurances.insuranceData.coverages.glassAmount")}
              rules={[validations.minNumber(1)]}
            >
              <InputNumber addon="euro" />
            </Form.Item>
          )}
        </Col>
      </Row>

      <Row gutter={rowGutter}>
        <Col span={colSpan}>
          <Form.Item
            name={[...formNameCoveragesPrefix, "animal"]}
            valuePropName="checked"
            rules={[validations.none]}
            initialValue={false}
          >
            <Checkbox>{t("contract.attrs.insurances.insuranceData.coverages.animal")}</Checkbox>
          </Form.Item>
        </Col>

        <Col span={colSpan}>
          <Form.Item
            name={[...formNameCoveragesPrefix, "element"]}
            valuePropName="checked"
            rules={[validations.none]}
            initialValue={false}
          >
            <Checkbox>{t("contract.attrs.insurances.insuranceData.coverages.element")}</Checkbox>
          </Form.Item>
        </Col>

        <Col span={colSpan}>
          <Form.Item
            name={[...formNameCoveragesPrefix, "injury"]}
            valuePropName="checked"
            rules={[validations.none]}
            initialValue={false}
          >
            <Checkbox>{t("contract.attrs.insurances.insuranceData.coverages.injury")}</Checkbox>
          </Form.Item>
        </Col>

        <Col span={colSpan}>
          <Form.Item
            name={[...formNameCoveragesPrefix, "theft"]}
            valuePropName="checked"
            rules={[validations.none]}
            initialValue={false}
          >
            <Checkbox>{t("contract.attrs.insurances.insuranceData.coverages.theft")}</Checkbox>
          </Form.Item>
        </Col>

        <Col span={colSpan}>
          <Form.Item
            name={[...formNameCoveragesPrefix, "vandalism"]}
            valuePropName="checked"
            rules={[validations.none]}
            initialValue={false}
          >
            <Checkbox>{t("contract.attrs.insurances.insuranceData.coverages.vandalism")}</Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
